import { render } from "./DeleteInformationPartsTable.vue?vue&type=template&id=88f0ee96"
import script from "./DeleteInformationPartsTable.vue?vue&type=script&lang=js"
export * from "./DeleteInformationPartsTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__